// HTML, который пишут заказчики (описание и контрольный вопрос задания, доработка, задания SDK),
// показываем только после очистки: без <script>, обработчиков вроде onerror=… и ссылок javascript:.
// Иначе такой текст выполнился бы в приложении у исполнителя, открывшего задание, — с его ключом
// сессии. Так же очищается HTML в кабинете upmob.ru (sanitizeHtml.js в upmob_lk_new).
import DOMPurify from 'dompurify';

const CONFIG = {
    ADD_ATTR: ['target'],
    FORBID_TAGS: ['style', 'form', 'input', 'button', 'textarea', 'select', 'option', 'iframe', 'object', 'embed'],
    FORBID_ATTR: ['srcset', 'formaction']
};

// Оформление (цвет, жирность, отступы) оставляем, но без свойств, которыми можно вынести блок
// поверх экрана (поддельная кнопка) или подгрузить что-то с чужого сервера.
const DANGEROUS_CSS_PROPERTY = /^(position|z-index|inset|top|left|right|bottom|transform|translate|rotate|scale|filter|backdrop-filter|pointer-events|cursor|content|clip-path|mask.*|behavior|-moz-binding)$/i;
const DANGEROUS_CSS_VALUE = /url\s*\(|expression\s*\(|@import|image-set\s*\(/i;

const cleanStyle = (style) => String(style || '')
    .split(';')
    .map((part) => part.trim())
    .filter((part) => {
        const idx = part.indexOf(':');
        if (idx <= 0) return false;
        const prop = part.slice(0, idx).trim();
        return !DANGEROUS_CSS_PROPERTY.test(prop) && !DANGEROUS_CSS_VALUE.test(part.slice(idx + 1));
    })
    .join('; ');

let hooked = false;
const ensureHooks = () => {
    if (hooked) return;
    hooked = true;
    DOMPurify.addHook('uponSanitizeAttribute', (node, data) => {
        if (data.attrName !== 'style') return;
        data.attrValue = cleanStyle(data.attrValue);
        if (!data.attrValue) data.keepAttr = false;
    });
    // ссылки в новой вкладке — без доступа к приложению (window.opener)
    DOMPurify.addHook('afterSanitizeAttributes', (node) => {
        if (node.tagName === 'A' && node.getAttribute('target')) {
            node.setAttribute('rel', 'noopener noreferrer');
        }
    });
};

export const sanitizeHtml = (html) => {
    if (html === null || html === undefined) return '';
    ensureHooks();
    return DOMPurify.sanitize(String(html), CONFIG);
};
